var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("rect",{"x":"4","y":"4","width":"16","height":"16","rx":"4","key":1}),React.createElement("circle",{"cx":"12","cy":"12","r":"3","key":2}),React.createElement("line",{"x1":"16.5","y1":"7.5","x2":"16.5","y2":"7.501","key":3})]);
}

Instagram.defaultProps = {"className":"icon icon-tabler icon-tabler-brand-instagram","width":"24","height":"24","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Instagram;

Instagram.default = Instagram;
